import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Create, FormManager, PageTitle } from 'gossamer-front-end';
import { getListRowLink } from 'gossamer-unified';
import { ControlVisibilityLimitOptions } from './ControlVisibilityLimitOptions';
import { useLocalEventProfile } from './useLocalEventProfile';

export const EventProfileCreate = (): React.JSX.Element => {
  const navigate = useNavigate();
  const { LocalEventProfile, override } = useLocalEventProfile();

  return (
    <>
      <PageTitle verb="Create" entity={LocalEventProfile} />
      <FormManager
        compoundUrl="/main/~/event-profile-create"
        handleCancel={() => navigate(`/admin/event-profile/search`)}
        handleSuccess={({ keyOfFirstCreate }) =>
          navigate(getListRowLink(LocalEventProfile.listRowLink, keyOfFirstCreate))
        }
        initialization={{
          main: { type: 'create-single', entity: LocalEventProfile, override },
        }}
      >
        <ControlVisibilityLimitOptions localEventProfile={LocalEventProfile} />
        <h6>Basic Details</h6>
        <Create valuesKey="main" entity={LocalEventProfile} fieldGroup="basic" />
        <h6>Event Engagement Settings</h6>
        <Create valuesKey="main" entity={LocalEventProfile} fieldGroup="engagement" />
        <h6>Audience Settings</h6>
        <Create valuesKey="main" entity={LocalEventProfile} fieldGroup="audience" />
        <h6>Post-Event Flow Settings</h6>
        <Create valuesKey="main" entity={LocalEventProfile} fieldGroup="post-event-flow" />
        <h6>Certificate Templates</h6>
        <Create valuesKey="main" entity={LocalEventProfile} fieldGroup="certificates" />
      </FormManager>
    </>
  );
};
